import {
    TextField,
    IconButton,
    InputAdornment,
    Button,
    InputLabel,
    Select,
    MenuItem,
    FormControl,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    ListItemButton, ListItemIcon, Checkbox
} from "@mui/material";
import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faTimes,faCalendarWeek
} from "@fortawesome/free-solid-svg-icons";
import {
    List,
    ListItem,
    ListItemText,
    Typography
} from "@mui/material";

Date.prototype.__GetFirstDayOfWeek = function() {
    return (new Date(this.setDate(this.getDate() - this.getDay() )));
}

export function convertDateToBallCalendar(date) {
    let d = new Date(date);
    let year = d.getFullYear();
    let firstDayOfYear = new Date(year, 0, 1);

    const firstWeekNumber = {
        0: 52, // sunday
        1: 1, // monday
        2: 1, // tuesday
        3: 1, // wednesday
        4: 1, // thursday
        5: 53, // friday
        6: 52  // saturday
    }
    let firstWeekValue = firstWeekNumber[firstDayOfYear.getDay()];
    let sundayPriorToStartOfYear = firstDayOfYear.__GetFirstDayOfWeek();
    let currentSunday = d.__GetFirstDayOfWeek();
    let NumberOfWeeks = Math.ceil(Math.floor((currentSunday - sundayPriorToStartOfYear) / (24 * 60 * 60 * 1000)) / 7);
    console.log(`NumberOfWeeks ${new Date(date).toLocaleDateString()} ${new Date(date).getDay()} ${NumberOfWeeks}`);
    if (currentSunday.getFullYear() !== d.getFullYear() ||  NumberOfWeeks === 0){
        return firstWeekValue;
    }
    else {
        if (firstWeekValue === 1){
            return NumberOfWeeks+1;
        }
        else {
            return NumberOfWeeks;
        }
    }
}

// for (let month = 0; month < 12; month++) {
//     for (let day = 0; day < 30; day++) {
//         let val = convertDateToBallCalendar(new Date(2021, month, day+1).toISOString())
//         console.log(` ${month+1}/${day+1}/2022  ${val} `)
//     }
// }

function getYears() {
    let years = []
    for (let i = new Date().getFullYear() - 10; i < new Date().getFullYear() + 5; i++) {
        years.push({ label: i, value: i});
    }
    return years;
}

function getWeeks(year) {
    if (year === undefined || year === null) return [];
    // let firstDayOfYear = new Date(year, 0, 1);
    // let firstWeekNumber = convertDateToBallCalendar(firstDayOfYear);
    let lastDayOfYear = new Date(year, 11, 31);
    let lastWeekNumber = convertDateToBallCalendar(lastDayOfYear);
    // alert(lastWeekNumber)

    console.warn(` GET WEEKS ${year} ${1} ${lastWeekNumber} `);

    let weeks = []

    for (let i = 0; i < lastWeekNumber; i++) {
        weeks.push({ label: i+1, value: i+1});
    }
    return weeks;
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

export function Form_WeekSelection(props) {
    const {item, localFormState, setLocalFormState} = props;
    const {inputSize = "normal", key, weekKey = "week", yearKey = "year"} = item;
    const [open, setOpen] = React.useState(false);

    const [year, setYear] = React.useState(new Date().getFullYear());
    const [years, setYears] = React.useState(getYears());
    const [week, setWeek] = React.useState(1);
    const [weeks, setWeeks] = React.useState();

    const [selectedWeeksWithoutYear, setSelectedWeeksWithoutYear] = React.useState([]);

    const [selectedWeeks, setSelectedWeeks] = React.useState([]);

    React.useEffect(() => {
        setWeeks(getWeeks(year));
    }, [year]);

    React.useEffect(() => {
        setWeeks(getWeeks(new Date().getFullYear()));
    }, [])

    React.useEffect(() => {
        if (localFormState !== undefined && localFormState[key] !== undefined && Array.isArray(localFormState[key])){
            setSelectedWeeks(localFormState[key]);
        }
    }, [localFormState[key]])

    const setFormWeek = () => {
        setLocalFormState({
            ...localFormState,
            [item.key] : [...new Set([...selectedWeeks])]
        });
    }

    React.useEffect(() => {
        if (localFormState[item.key] === null || localFormState[item.key] === undefined) {
            let obj = { week: convertDateToBallCalendar(new Date()), year: new Date().getFullYear()}
            localFormState[item.key] = [obj]
        }
    }, [localFormState]);

    const selectWeek = () => {
        console.log(selectedWeeksWithoutYear)
        selectedWeeksWithoutYear.forEach((__week__) => {
            let obj = { week:__week__, year };
            if (selectedWeeks.map(x => `${x.week}/${x.year}`).indexOf(`${obj.week}/${obj.year}`) === -1){
                setSelectedWeeks((current) => [...current, obj].sort(((a, b) => {
                    if (a.year > b.year) {
                        return 1;
                    }
                    else if (b.year > a.year){
                        return -1;
                    }
                    else {
                        return a.week > b.week ? 1 : -1
                    }
                })));
            }
        });

        setSelectedWeeksWithoutYear([]);

        // let obj = { week, year };
        // if (selectedWeeks.map(x => `${x.week}/${x.year}`).indexOf(`${obj.week}/${obj.year}`) === -1){
        //     setSelectedWeeks((current) => [...current, obj]);
        // }
    };

    const deselectWeek = (week) => {
        setSelectedWeeks((current) => current.filter(i => i !== week));
    }

    return (<>
        {(open) && (
            <Dialog
                open={true}
                onClose={() => setOpen(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth={"xl"}
            >
                <DialogTitle id="alert-dialog-title" style={{textAlign: "center"}}>
                    Select Week
                </DialogTitle>
                <DialogContent style={{width: '600px', padding: '0.5rem', display: 'flex', flexDirection: "column", gap: '1rem'}}>

                    <div style={{display: 'flex', flexDirection: 'row', gap: '1rem'}}>
                        <div style={{ display: 'flex', flexDirection: 'column', width: '50%', gap: '1rem' }}>
                            <FormControl fullWidth>
                                <InputLabel id="year">Year</InputLabel>
                                <Select
                                    labelId="year"
                                    id="year-select"
                                    value={year}
                                    label="Year"
                                    onChange={(e) => setYear(e.target.value)}
                                >
                                    {years.map((i) => <MenuItem key={i.value} value={i.value}>{i.label}</MenuItem>)}
                                </Select>
                            </FormControl>
                            {year !== undefined && year !== null && (
                                <FormControl fullWidth>
                                    <InputLabel id="week">Week</InputLabel>
                                    <Select
                                        labelId="week"
                                        id="year-select"
                                        value={selectedWeeksWithoutYear}
                                        label="Week"
                                        multiple
                                        renderValue={(selected) => selected.join(', ')}
                                        MenuProps={MenuProps}
                                        onChange={(event) => {
                                            const {
                                                target: { value },
                                            } = event;
                                            setSelectedWeeksWithoutYear(
                                                // On autofill we get a stringified value.
                                                typeof value === 'string' ? value.split(',') : value,
                                            );
                                        }}
                                    >
                                        {weeks.map((i) => <MenuItem
                                            disabled={selectedWeeks.map(x => `${x.week}/${x.year}`).indexOf(`${i.value}/${year}`) !== -1}
                                            key={i.value} value={i.value}>
                                            <Checkbox checked={selectedWeeksWithoutYear.indexOf(i.value) > -1} />
                                            <ListItemText primary={i.label} />
                                            {/*{i.label}*/}
                                        </MenuItem>)}

                                    </Select>
                                    {/*<Select*/}
                                    {/*    labelId="week"*/}
                                    {/*    id="year-select"*/}
                                    {/*    // value={week}*/}
                                    {/*    label="Week"*/}
                                    {/*    // onChange={handleChange}*/}
                                    {/*    // onChange={(e) => setWeek(e.target.value)}*/}
                                    {/*>*/}
                                    {/*    {weeks.map((i) => <MenuItem disabled={selectedWeeks.map(x => `${x.week}/${x.year}`).indexOf(`${i.value}/${year}`) !== -1} key={i.value} value={i.value}>{i.label}</MenuItem>)}*/}
                                    {/*</Select>*/}
                                </FormControl>
                            )}

                            {/*<pre>{JSON.stringify(selectedWeeksWithoutYear, undefined, 4)}</pre>*/}

                            <Button onClick={() => selectWeek()} disabled={selectedWeeks.map(x => `${x.week}/${x.year}`).indexOf(`${week}/${year}`) !== -1} variant={"contained"} color={"secondary"} fullWidth={true}>Add</Button>

                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1, gap: '1rem', maxHeight: '400px', overflowY: 'scroll'}}>
                            {selectedWeeks.length === 0 && (<Typography style={{textAlign: 'center'}}>No Weeks Selected</Typography>)}
                            <List dense component="div" role="list">
                                {selectedWeeks.map((value) => {
                                    // return (<pre>{JSON.stringify(value)}</pre>)
                                    const labelId = `transfer-list-all-item-${value}-label`;
                                    return (
                                        <ListItem
                                            key={value.week + " " + value.year}
                                            role="listitem"
                                        >
                                            <ListItemButton role={undefined}
                                                            onClick={() => deselectWeek(value)}
                                                            // onClick={handleToggle(value)}
                                                            dense>
                                                <ListItemIcon>
                                                    <FontAwesomeIcon style={{color: 'red'}} icon={faTimes} />
                                                </ListItemIcon>
                                                <ListItemText id={labelId} primary={`${value.week} / ${value.year}`}/>&nbsp;
                                            </ListItemButton>
                                        </ListItem>
                                    );
                                })}
                            </List>
                        </div>
                    </div>


                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {
                        // updateLocalDate();
                        setOpen(false);
                    }}>Cancel</Button>
                    <Button color={'secondary'} onClick={() => {
                        setFormWeek();
                        setOpen(false);
                    }} autoFocus>Set</Button>
                </DialogActions>
            </Dialog>

        )}
        <TextField
            label={item.label}
            helperText={item.helperText}
            variant="outlined"
            fullWidth={true}
            size={inputSize}
            InputLabelProps={{shrink: true}}
            disabled={true}
            InputProps={{
                endAdornment:
                    <InputAdornment position="end" style={{ paddingRight: '0.5rem'}}>
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setOpen(true)}
                            edge="end"
                        >
                            {/*<CalendarTodayIcon/>*/}
                            <FontAwesomeIcon icon={faCalendarWeek} />
                        </IconButton>
                    </InputAdornment>
            }}
            value={ localFormState[key] !== undefined ? localFormState[key].map(x => `${x.week}/${x.year}`).join(', ') || "" : ""}
        />
    </>);
}